import PlanLimitsCard from '@/components/subscription/PlanLimitsCard'
import Panel from '@/components/common/Panel'
import { usageData } from '@/data/usage'

interface Props {
  className?: string
}

const PlanLimits = (props: Props) => {
  const usage = usageData

  return (
    <div className={`p-4 ${props.className}`}>
      <Panel title="Plan limits">
        <div className="text-sm pb-2">Limits</div>
        {/* Wide: single table with all plans */}
        {/* @@TODO: Remove/add max-w-fit to enable/disable scaling width */}
        <div className="3xs:max-xs:hidden max-w-fit">
          <div className="border border-gray-200 dark:border-gray-700">
            <div className="overflow-x-auto">
              <div className="flex justify-between">
                <div className="flex justify-begin bg-green-400">
                  <div className="min-w-14">
                    <div className="h-6 bg-blue-400 whitespace-nowrap font-semibold">
                      Feature
                    </div>
                    <div className="h-6 bg-red-400">Groups</div>
                    <div className="h-6 bg-blue-400 ">Sites</div>
                    <div className="h-6 bg-red-400">Users</div>
                  </div>
                </div>
                <div className="flex justify-end bg-purple-400">
                  {usage.map((usage) => (
                    <PlanLimitsCard key={usage.id} usage={usage} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Narrow: one table per plan */}
        {/* @@TODO: Remove/add max-w-fit to enable/disable scaling width */}
        <div className="xs:hidden max-w-fit">
          <div className="grid grid-cols-1 2xs:grid-cols-2 gap-x-4 gap-y-2">
            {usage.map((usage) => (
              <div
                key={usage.id}
                className="border border-gray-200 dark:border-gray-700 mb-2"
              >
                <div className="overflow-x-auto">
                  <div className="flex justify-between">
                    <div className="flex justify-begin bg-green-400">
                      <div className="min-w-14">
                        <div className="h-6 bg-blue-400 whitespace-nowrap font-semibold">
                          Feature
                        </div>
                        <div className="h-6 bg-red-400">Groups</div>
                        <div className="h-6 bg-blue-400 ">Sites</div>
                        <div className="h-6 bg-red-400">Users</div>
                      </div>
                    </div>
                    <div className="flex justify-end bg-purple-400">
                      <PlanLimitsCard key={usage.id} usage={usage} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Panel>
    </div>
  )
}

export default PlanLimits
